import { LoanConsent } from "../../../models/legalConsent/loanConsent";
import { RegisterConsentResponse } from "../../../models/legalConsent/registerConsentResponse";

export const getConsentsSet: LoanConsent = {
  consentData: [
    {
      bfeNumber: "8923139825",
      isOwner: true,
      loanCaseCPRNumber: "0112200150",
      consentId: "SAM-000127",
      dueDate: "03/17/2023",
      consentGivenDateTime: "2024-03-17T23:54:02",
      consentGiven: true,
      lanCaseLastName: "Nielsen",
      loanCaseFirstName: "Mette",
      collateralAmount: "30000",
      cprNumber: "0202776666",
      bfeDescription: "NÃ¸rregade, 5, A, 9800, HjÃ¸rring",
    },
    {
      loanCaseCPRNumber: "0202776666",
      isOwner: false,
      bfeNumber: "8923139825",
      consentId: "SAM-000131",
      dueDate: "03/17/2023",
      consentGivenDateTime: "",
      consentGiven: true,
      lanCaseLastName: "Nielsen",
      loanCaseFirstName: "Mette",
      collateralAmount: "201",
      cprNumber: "0202776666",
      bfeDescription: "NÃ¸rregade, 6, A, 9800, HjÃ¸rring",
    },
    {
      bfeNumber: "8923139825",
      loanCaseCPRNumber: "0202776666",
      isOwner: false,
      consentId: "SAM-000133",
      dueDate: "03/17/2023",
      consentGivenDateTime: "",
      consentGiven: false,
      lanCaseLastName: "Nielsen",
      loanCaseFirstName: "Mette",
      collateralAmount: "202",
      cprNumber: "0202776666",
      bfeDescription: "NÃ¸rregade, 7, A, 9800, HjÃ¸rring",
    },
    {
      bfeNumber: "8923139825",
      loanCaseCPRNumber: "0112200150",
      isOwner: true,
      consentId: "SAM-000128",
      dueDate: "03/17/2023",
      consentGivenDateTime: "",
      consentGiven: false,
      lanCaseLastName: "Nielsen",
      loanCaseFirstName: "Mette",
      collateralAmount: "35000",
      cprNumber: "0202776666",
      bfeDescription: "NÃ¸rregade, 8, A, 9800, HjÃ¸rring",
    },
  ],
};

export const getRegisterConsent: RegisterConsentResponse = {
  consentId: "consentId",
};
